module.exports = __webpack_public_path__ + "static/media/n-53-shot-01.8c0f02e5.webp";